import React, { useState, useEffect } from "react";
import "./HomeUsage.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "antd";
import { FaCalendar } from "react-icons/fa";
import Piechart from "../Piechart";
import { IoMdAdd } from "react-icons/io";
import { Dashboard_Quick_Actions_Created_ActionHandler } from "../../../Redux/Actions/user/DashboardQuickActionsCreated";
import { Dashboard_Time_Created_ActionHandler } from "../../../Redux/Actions/user/DashboardTimeCreated";
import Loader from "../../../Components/Loader/Loader";

const LinearEdit = "/assets/linear_edit.svg";
const Home_logo = "/assets/home-logo.svg";
const GrowthIcon = "/assets/GrowthIc.svg";
const NoActivityFoundLogo = "assets/no-activity-found.svg";

const HomeUsage = () => {
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  const [setusageanalytics, setUsageAnalytics] = useState("month");
  const dashboardquickactionscreateddata = useSelector(
    (state) =>
      state?.Dashboard_Quick_Actions_Created_Data
        ?.dashboard_quick_actions_created_data
  );
  const dashboardtimecreateddata = useSelector(
    (state) => state?.Dashboard_Time_Created_Data?.dashboard_time_created_data
  );

  useEffect(() => {
    dispatch(Dashboard_Quick_Actions_Created_ActionHandler(setusageanalytics));
    dispatch(Dashboard_Time_Created_ActionHandler(setusageanalytics));
  }, []);
  const handleClick = () => {
    window.dataLayer.push({
      event: "Navigate",
      buttonName: "Build a QuickAction",
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
    Navigate("/build-quick-action");
  };

  const handleAnalyticsClick = (value) => {
    setUsageAnalytics(value);
    dispatch(Dashboard_Quick_Actions_Created_ActionHandler(value));
    dispatch(Dashboard_Time_Created_ActionHandler(value));

    //gtm
    window.dataLayer.push({
      event: value + "reports",
      buttonName: value,
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
  };
  return (
    <>
      {dashboardquickactionscreateddata ? (
        <div className="home-usage-container">
          {/* left */}
          <div className="home_upper_left-conatiner">
            <div className="left-time-action-usage">
              <h4>
                <FaCalendar /> QuickActions Usage
              </h4>
              <div className="usage-analytics-main">
                <div>
                  <div className="rectangle-parent9">
                    <button
                      className={
                        setusageanalytics === "today"
                          ? `butttonusageanalytics activeusageanalytics`
                          : `butttonusageanalytics`
                      }
                      onClick={(e) => handleAnalyticsClick("today")}
                    >
                      Today
                    </button>
                    <button
                      className={
                        setusageanalytics === "week"
                          ? `butttonusageanalytics activeusageanalytics`
                          : `butttonusageanalytics`
                      }
                      onClick={(e) => handleAnalyticsClick("week")}
                    >
                      Week
                    </button>
                    <button
                      className={
                        setusageanalytics === "month"
                          ? `butttonusageanalytics activeusageanalytics`
                          : `butttonusageanalytics`
                      }
                      onClick={(e) => handleAnalyticsClick("month")}
                    >
                      Month
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="left-created-action-usage">
              <Card bordered={false} style={{ width: "25vw" }}>
                <div className="quick-action-created">
                  <div>
                    <p className="quick-action-font">
                      QuickAction <b>Created</b>
                    </p>
                  </div>
                  <div>
                    <img
                      src={LinearEdit}
                      className="quick-action-logo"
                      alt=""
                    />
                  </div>
                </div>
                <div className="quick-action-text">
                  <p className="big-font-text">
                    <span className="big-font">
                      {dashboardquickactionscreateddata?.num_user}
                    </span>
                    /{dashboardquickactionscreateddata?.num_team}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Me/Account</b>
                  </p>
                </div>
                <hr className="action-separator" />
                <div className="quick-action-growth">
                  <div>
                    <p className="quick-action-growth-btn">
                      <img src={GrowthIcon} alt="" />+
                      {dashboardquickactionscreateddata?.per_increased}%
                    </p>
                  </div>
                  <p>From yesterday</p>
                </div>
              </Card>

              <Card bordered={false} style={{ width: "25vw" }}>
                <div>
                  <div>
                    <p className="quick-action-font">Time Created</p>
                    {dashboardtimecreateddata?.num_user ||
                    dashboardtimecreateddata?.num_team ? (
                      <div className="quick-action-time">
                        <Piechart
                          numUser={dashboardtimecreateddata?.num_user}
                          numTeam={dashboardtimecreateddata?.num_team}
                        />
                        <div>
                          <div className="quick-action-dots">
                            <p
                              style={{
                                color: "#EE3E38",
                                marginRight: "5px",
                              }}
                            >
                              ●
                            </p>
                            <p>Created By You</p>
                          </div>
                          <div className="quick-action-dots">
                            <p
                              style={{
                                color: "#FDECEB",
                                marginRight: "5px",
                              }}
                            >
                              ●
                            </p>
                            <p>Created By Your Team</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="quick-action-no-activity-found-wrapper">
                        <img
                          src={NoActivityFoundLogo}
                          className="no-activity-found-logo"
                          alt=""
                        />
                        <div className="no-activity-found-text">
                          No Activity Found.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          </div>

          {/* Build a QuickAction */}
          <div className="home_upper_right-conatiner">
            <Card className="card-right">
              <img src={Home_logo} alt="" />
              <div className="circle-red"></div>
              <div className="ractangle-green"></div>
              <div className="card-right-btn">
                <Button className="main-api" onClick={handleClick}>
                  <IoMdAdd />
                  Build a QuickAction
                </Button>
              </div>
            </Card>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default HomeUsage;
